exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 0